'use strict';
const { createAddQueries } = require('../addQueries');
const {
  id,
  payerId,
  userId,
  createFilterConfig,
} = require('./commons');

module.exports = createAddQueries({
  returnModel: {
    name: 'payeruser',
  },
  finders: [
    id,
    payerId,
    userId,
  ],
  orderBy: [
    id,
    payerId,
    userId,
    'email',
    'role',
    'status',
    createFilterConfig('firstName', 'firstname'),
    createFilterConfig('lastName', 'lastname'),
  ],
});
